/** @format */

import template from './gb-styles.html';

export const GbStylesComponent = {
    template,
    controller: class GbStylesComponent {
        constructor($mdColors, $ccColors) {
            'ngInject';

            this.$mdColors = $mdColors;
            this.$ccColors = $ccColors;
        }

        setColors() {
            this.backgroundDefault = this.$mdColors.getThemeColor('background');
            this.backgroundDefaultContrast = this.$ccColors.getContrast(this.background100);

            this.primaryDefault = this.$mdColors.getThemeColor('primary');
            this.primaryDefaultContrast = this.$ccColors.getContrast(this.primaryDefault);
        }

        getStyles() {
            this.styles = `
                gb-add-widget-panel md-list-item.selected-button {
                    background-color: ${this.primaryDefault};
                    color: ${this.primaryDefaultContrast};
                }
            `;

            return this.styles;
        }

        $onInit() {
            this.setColors();
        }
    },
};
